<template>
  <ListView
    :key="`${source}-listview`"
    :headers="headers"
    :items="items"
    :unfiltered="unfiltered"
    :pagination="pagination"
    :handleSort="handleSort"
    :updatePagination="updatePagination"
    :selection="selection"
    :emitSelection="updateSelected"
    :selectAll="selectAll"
    :selectNone="selectNone"
    :listViewType="listView"
    :isLoading="isLoading"
    :count="count"
    :totalCount="totalCount"
    :selectActions="selectActions"
    :dataActions="dataActions"
    :quickSearch="quickSearch"
    :updateQuickSearch="updateQuickSearch"
    :searchFields="doc.list.search"
    :selectView="selectView"
    :searchForm="search"
    :handleSearch="handleSearch"
    :hasMap="hasMap"
    :hasLine="context.hasLine"
    :hasCard="context.hasCard"
    :handleSearchReset="handleSearchReset"
    :updateSearchField="updateSearchField"
  />
</template>

<script>
import ListView from '@/components/list/ListView'
import Confirm from '@/components/adhoc/Confirm'
import { makeAccessors, filterActions } from '@/utils'
import merge from 'deepmerge'
import { create } from 'vue-modal-dialogs'

const actionConfirm = create(Confirm)

export default {
  components: {
    ListView,
  },
  computed: {
    isLoading () { return this.$store.getters[`${this.source}/isLoading`] },
    scope () { return this.$store.getters['auth/scope'] },
    doc () { return this.$store.getters[`${this.source}/doc`] },
    pagination () { return this.$store.getters[`${this.source}/pagination`] },
    selection () { return this.$store.getters[`${this.source}/selectedItems`] },
    items () { return this.$store.getters[`${this.source}/items`] },
    unfiltered () { return this.$store.getters[`${this.source}/unfiltered`] },
    totalCount () { return this.$store.getters[`${this.source}/totalCount`] },
    headers () { return this.list.headers },
    listView () { return this.$store.getters[`${this.source}/listView`] },
    search () { return this.$store.getters[`${this.source}/search`] },
    quickSearch () { return this.$store.getters[`${this.source}/quickSearch`] },
    hasMap () { return this.doc.list.hasMap },
    dataActions () {
      let filtered = filterActions(this.list.dataActions, {}, this.scope)
      return filtered.map(action => ({
        ...action,
        callBack: item => {
          let context = action.context
            ? { ...this.context, ...action.context }
            : { ...this.context }
          let payload = {
            accessors: {},
            context,
          }
          this.$store.dispatch(action.dispatch, { ...payload, data: item })
        },
      }))
    },
    selectActions () {
      let accessors = makeAccessors(this.list.headers)
      let payload = {
        accessors,
        data: this.selection,
        context: this.context,
      }
      let filtered = filterActions(this.list.selectActions, {}, this.scope)
      return filtered.map(action => {
        let modifiedPayload = merge(payload, {context: action.context ? action.context : {}})
        return {
          ...action,
          callBack: () => { this.callBackMiddleware(action.dispatch, modifiedPayload) },
        }
      })
    },
    count () { return this.selection.length },
  },
  methods: {
    updateSelected (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/updateSelected`, payload)
    },
    selectAll (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/selectAll`, payload)
    },
    selectNone (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/selectNone`, payload)
    },
    handleSort (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/updateSort`, payload)
    },
    updatePagination (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/updatePagination`, payload)
    },
    callBackMiddleware (dispatch, payload) {
      let confirm = payload.context.confirm || false
      if (confirm) {
        actionConfirm({
          question: 'Voulez-vous confirmer cette action?',
        })
          .then(data => {
            console.log('ok', dispatch, payload)
            this.$store.dispatch(dispatch, payload)
          })
          .catch(error => {
            console.log('error', error)
          })
      } else {
        this.$store.dispatch(dispatch, payload)
      }
    },
    handleSearch () {
      this.refresh()
    },
    updateQuickSearch (value) {
      this.$store.dispatch(`${this.source}/smartSearch`, value)
    },
    handleSearchReset () {
      let payload = {
        accessors: {},
        context: this.context,
        data: {},
      }
      this.$store.dispatch(`${this.source}/smartSearch`, '')
      this.$store.dispatch(`${this.source}/resetSearch`, payload)
        .then(() => {
          this.refresh()
        })
    },
    updateSearchField (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/updateSearchField`, payload)
    },
    refresh () {
      let payload = {
        accessors: {},
        context: this.context,
        data: this.search.data,
      }
      if (this.context.customDispatch) {
        const { origin, customDispatch } = this.context
        console.log(`ListContainer: ${this.source} using ${customDispatch}`)
        this.$store.dispatch(`${origin}/${customDispatch}`, payload)
      } else {
        console.log(`ListContainer: ${this.source} using fetchAll`)
        this.$store.dispatch(`${this.source}/fetchAll`, payload)
      }
    },
    selectView (data) {
      let payload = {
        accessors: {},
        context: this.context,
        data,
      }
      this.$store.dispatch(`${this.source}/setListView`, payload)
    },
  },
  props: {
    error: { type: Boolean, default: false },
    source: String,
    list: Object,
    context: Object,
  },
  created () {
    console.log(`ListContainer: ${this.source} created`)
    // console.log('ListContainer context', this.context)
    if (!this.error) {
      this.refresh()
    }
  },
  destroyed () {
    console.log(`ListContainer: ${this.source} destroyed`)
  },
}
</script>
